import React, { Component } from 'react';
import { UserMenu, LoginRegisterButtons } from '../../components'
import { connect } from 'react-redux';
import history from '../../helpers/history';
import { Layout, Menu, Row, Col, Modal, Alert, message, notification, Button } from 'antd';
import emitter from '../Evt.js';

import WrappedLoginForm from '../../pannels/form/LoginForm';
import WrappedRegisterForm from '../../pannels/form/RegisterForm';

import $ from 'jquery';
window.jQuery = $;
require('signalr');

const { Header } = Layout;
const SubMenu = Menu.SubMenu;

var languageMessages = window.appLocale.messages;

var hubConnection = null;
var hubProxy = null;
var isHubConnection = 0;

var testMode = false;

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

const loginSysMessageStatus = 'loginSysMessageStatus';

let headerTimer = null;
class HeaderPage extends Component {
    constructor(props) {
        super(props);

        var auth = JSON.parse(localStorage.getItem("auth") || '{}') || {};

        var current = sessionStorage.getItem("MainMenuSelectKey") || 'scan';
        
        this.state = {
            current: current,
            userId: '',
            photo: '',

            loggedIn: false,

            modalVisible: false,
            isGetCaptcha: true,
            count: 60,
            code: '',
            message: '',
            logining: false,
            registered: false,

            alertVisible: false,
            hawkeye: {},

            orderVisible: false,
            order: {},

            showLogin: true,
            showRegister: false,
            showClass: 'login-register-btn-class',

            ...auth
        };
    }

    componentDidMount() {
        emitter.addListener('callJump', (msg) => {
            this.setState({
                current: msg,
            });

            sessionStorage.setItem("MainMenuSelectKey", msg);
        });

        emitter.addListener('callIntradayData', (symbol, period) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === undefined) {
                // 没有登录
            } else {
                this.SendIntradayDataToService(user.username, symbol, period);
            }
        });

        emitter.addListener('HawkeyeConfirm', (hawkeyeId, confirmResult) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === undefined) {
                // 没有登录
            } else {
                var txt = confirmResult === 0 ? languageMessages['ClosePendingOrder'] : languageMessages['PendingOrderHawkeye'];
                this.SendHawkeyeConfirm(user.username, hawkeyeId, confirmResult, txt);
            }
        });
    }

    componentWillMount() {
        var userId = '';
        var photo = '';
        var loggedIn = false;
        var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
        if (user.username !== undefined) {
            userId = user.username;
            var timestamp = new Date().getTime();
            photo = user.photo ? user.photo + '?now=' + timestamp : '/static/photo/photo.png';
            loggedIn = true;

            if (isHubConnection !== 1) {
                if (!testMode) this.setupConnect();
            }
        }

        this.setState({
            userId: userId,
            photo: photo,
            loggedIn: loggedIn,
        });
    }

    componentDidUpdate() {
        if (this.state.loggedIn) {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === undefined) {
                if (hubConnection !== null) {
                    hubConnection.stop();
                }

                this.setState({
                    userId: '',
                    photo: '',
                    loggedIn: false,
                });
            }
        }
    }

    componentWillUnmount() {
        if (hubConnection !== null) {
            hubConnection.stop();
        }
    }

    componentWillReceiveProps(props) {
        var { status, state, user, data } = props.member;
        var { count } = this.state;

        this.setState({
            code: '',
            message: '',
            logining: false,
            registered: false
        }, () => {
            var failStatus = props.fail.status !== undefined ? props.fail.status : '';
            if (failStatus === 'non_user') {
                sessionStorage.removeItem('auth');
                this.setState({
                    modalVisible: true, loggedIn: false, userId: '', photo: '', showLogin: true,
                    showRegister: false });
            } else {
                switch (status) {
                    case 'Get_Captcha':
                        switch (state) {
                            case 0://失败
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['get.verification.code.failed']
                                });
                                break;
                            case 1://成功
                                headerTimer = setInterval(() => {
                                    this.setState({
                                        isGetCaptcha: false,
                                        count: (count--)
                                    }, () => {
                                        if (count === 0) {
                                            clearInterval(headerTimer);
                                            this.setState({
                                                isGetCaptcha: true,
                                                count: 60
                                            })
                                        }
                                    })
                                }, 1000);
                                break;
                            case 2://手机未注册
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['phone.not.register']
                                });
                                break;
                            case 3://手机有误
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['phone.format.failed']
                                });
                                break;
                            default:
                                break;
                        }
                        break;
                    case 'Get_Email_Captcha':
                        switch (state) {
                            case 0://失败
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['get.verification.code.failed']
                                });
                                break;
                            case 1://成功
                                headerTimer = setInterval(() => {
                                    this.setState({
                                        isGetCaptcha: false,
                                        count: (count--)
                                    }, () => {
                                        if (count === 0) {
                                            clearInterval(headerTimer);
                                            this.setState({
                                                isGetCaptcha: true,
                                                count: 60
                                            })
                                        }
                                    })
                                }, 1000);
                                break;
                            case 2://邮箱已注册
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['email.registered']
                                });
                                break;
                            case 3://邮箱有误
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['email.format.failed']
                                });
                                break;
                        }
                        break;
                    case 'Register_Success':
                        if (headerTimer !== null) {
                            clearInterval(headerTimer);
                        }
                        if (!testMode) {
                            this.setupConnect();

                            message.loading({ content: languageMessages['startConnectSysEngine'], key: loginSysMessageStatus, duration: 0 });

                            var tn = sessionStorage.getItem("TriggerNumberCache");
                            if (tn > 0) this.openNotification(tn);
                        }
                        this.setState({ userId: user.username, photo: '/static/photo/photo.png', loggedIn: true, modalVisible: false }, () => {
                            emitter.emit('initPage', isHubConnection);
                        });
                        break;
                    case 'Login_Success':
                        if (headerTimer !== null) {
                            clearInterval(headerTimer);
                        }
                        if (!testMode) {
                            this.setupConnect();

                            message.loading({ content: languageMessages['startConnectSysEngine'], key: loginSysMessageStatus, duration: 0 });

                            var tn = sessionStorage.getItem("TriggerNumberCache");
                            if (tn > 0) this.openNotification(tn);
                        }
                        var photo = user.photo ? user.photo + '?now=' + timestamp : '/static/photo/photo.png';
                        this.setState({ userId: user.username, photo: photo, loggedIn: true, modalVisible: false }, () => {
                            //var pathname = window.location.pathname;
                            //sessionStorage.setItem('pathname', pathname);
                            //history.replace("/blank");
                            emitter.emit('initPage', isHubConnection);
                        });
                        break;
                    case 'update_user_success':
                        if (user.photo !== undefined) {
                            var photo = user.photo;
                            var timestamp = new Date().getTime();
                            photo = photo ? photo + '?now=' + timestamp : '/static/photo/photo.png';
                            this.setState({ photo: photo });
                        }
                        break;
                    case 'Logout_Success':
                        this.setState({ userId: '', photo: '', loggedIn: false }, () => {
                            // disconnection
                            if (hubConnection !== null) {
                                hubConnection.stop();
                            }
                        });
                        break;
                    case 'Logining':
                        this.setState({
                            logining: true,
                        });
                        break;
                    case 'Registered':
                        this.setState({
                            registered: true,
                        });
                        break;
                    case 'Login_Failed':
                        if (headerTimer !== null) {
                            clearInterval(headerTimer);
                        }
                        switch (state) {
                            case 0:
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['login.exception']
                                });
                                break;
                            case 2:
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['account.not.register']
                                });
                                break;
                            case 3:
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['account.exception']
                                });
                                break;
                            case 4:
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['password.or.verification.code.match.error']
                                });
                                break;
                            case 5:
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['user.account.has.expired']
                                });
                                break;
                            default:
                                break;
                        }
                        break;
                    case "Register_Failed":
                        if (headerTimer !== null) {
                            clearInterval(headerTimer);
                        }
                        switch (state) {
                            case 0:
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['register.exception']
                                });
                                break;
                            case 2:
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['account.is.exist']
                                });
                                break;
                            case 3:
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['verification.code.matching.error']
                                });
                                break;
                            case 4:
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['register.failed']
                                });
                                break;
                            case 5:
                                this.setState({
                                    code: 'ERROR',
                                    message: languageMessages['promoCode.error']
                                });
                                break;
                            default:
                                break;
                        }
                        break;
                    case 'sendHubMessage':
                        this.SendMessageToService(data.service, data.userId, data.msg);
                        break;
                    default:
                        break;
                }
            }
        });
    }

    setupConnect() {
        var url = process.env.REACT_APP_HAWKEYE_BASE_URL + '/signalr';

        var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
        hubConnection = $.hubConnection(url, { useDefaultPath: false, qs: { userId: user.username, password: user.password } });

        //hubConnection.logging = true;

        
        hubConnection.connectionSlow(function () {
            message.warn('We are currently experiencing difficulties with the connection.')
        });

        /**
        hubConnection.starting(function () {
            //console.log('starting');
        });

        hubConnection.received(function (message) {
            //console.log('received', message);
        });
        
        hubConnection.reconnecting(function () {
            //console.log('reconnecting');
        });

        hubConnection.reconnected(function () {
            //console.log('reconnected');
        });
        */

        hubConnection.stateChanged(function (data) {
            isHubConnection = data.newState;
        });

        hubConnection.disconnected(() => {
            if (this.state.loggedIn) {
                var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
                if (user.username !== undefined) {
                    setTimeout(function () {
                        hubConnection.start()
                            .done(function () {
                                console.log('Connection started!');
                                message.success({ content: languageMessages['connectToSysEngineSucc'], key: 'connectStatus' });
                            })
                            .fail(function (error) {
                                message.error({ content: languageMessages['connectToSysEngineFail'], key: 'connectStatus', duration: 5});
                                //console.log('Could not connect', error);
                            });
                    }, 5000);
                } else {
                    this.setState({ userId: '', photo: '', loggedIn: false });
                }
            }
        });

        hubConnection.error(function (error) {
            //console.log('SignalR error', error);
            //message.error(languageMessages['connectToSysEngineError']);
        });

        hubProxy = hubConnection.createHubProxy('hubController');
        
        hubProxy.on('ReceiveLoginStatus', (userName, loginStatus) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                if (loginStatus == 1)
                    message.success({ content: languageMessages['loginRequestSucc'], key: 'loginStatus', duration: 5 });
                else
                    message.error({ content: languageMessages['logintRequestFail'], key: 'loginStatus', duration: 6 });
            }
        });
        hubProxy.on('ReceiveSmartHawkeyeMessage', (items, lastTimes) => {
            emitter.emit('submitHawkeye', lastTimes, items);
        });
        hubProxy.on('ReceiveFilterSuccMessage', (userName, status) => {
            //message.info('ReceiveFilterSuccMessage');
            //console.log('ReceiveFilterSuccMessage', status);
        });
        hubProxy.on('ReceiveFilterFailMessage', (userName, desc) => {
            message.error(strReplace(languageMessages['hawkeyeCondFail'], { '{cont}': desc }));
            //console.log('盯盘条件有错误', desc);
        });
        hubProxy.on('ReceiveCancelHawkeyeMessage', (userName, hawkeyeId) => {
            //console.log('ReceiveCancelHawkeyeMessage', hawkeyeId);

            //转发消息
            //emitter.emit('callHawkeye', hawkeyeId,1);
        });
        hubProxy.on('ReceiveTriggerHawkeyeMessage', (hawkeye) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === hawkeye.UserName) {
                if (this.state.current === 'hawkeyeList') {
                    emitter.emit('triggerHawkeye', hawkeye);
                }
                
                this.setState({ alertVisible: true, hawkeye });
            }
        });
        hubProxy.on('ReceiveOrderMessage', (userName, order) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                if (this.state.current === 'hawkeyeList' && order.Id !== undefined) {
                    var hawkeyeIds = [order.Id || '0'];
                    emitter.emit('callHawkeye', hawkeyeIds, 1);
                }

                this.setState({ orderVisible: true, order });
            }
        });

        hubProxy.on("ReceiveBacktestError", (userName, backtestStatus, backtest) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                let callback = '';
                switch (backtest.Type) {
                    case "backtestStrategy":
                        callback = 'callBacktestError';
                        break;
                    case "backtestGridStrategy":
                        callback = 'callBacktestGridError';
                        break;
                    case "exploreQTGrid":
                        callback = 'callBacktestGridsError';
                        break;
                    case "exploreGridStrategy":
                        callback = 'callOptimalGridError';
                        break;
                    case "aiBatch":
                        callback = 'callBestFromBatchBacktestError';
                        break;
                    case "optimalBatch":
                        callback = 'callOptimalBatchError';
                        break;
                    case "aiOpt":
                        callback = 'callAIOptBacktestError';
                        break;
                    case "optimalOpt":
                        callback = 'callOptimalOptError';
                        break;
                    case "rollingBacktest":
                        callback = 'callRollingError';
                        break;
                    case "porrtfolioBacktest":
                        callback = 'callPortfolioOptError';
                        break;
                    case "porrtfolioOptBacktest":
                        callback = 'callPortfolioOptError';
                        break;
                    default:
                        break;
                }
                if (callback !== '') {
                    emitter.emit(callback, backtestStatus);
                }
            }
        });

        hubProxy.on('ReceiveBacktestLastTimes', (userName, items, lastTimes, backtest) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                let callback = '';
                switch (backtest.Type) {
                    case "backtestStrategy":
                        callback = 'callBacktestLastTimes';
                        break;
                    case "backtestGridStrategy":
                        callback = 'callBacktestGridLastTimes';
                        break;
                    case "exploreQTGrid":
                        callback = 'callBacktestGridsLastTimes';
                        break;
                    case "exploreGridStrategy":
                        callback = 'callOptimalGridLastTimes';
                        break;
                    case "aiBatch":
                        callback = 'callBestFromBatchBacktestLastTimes';
                        break;
                    case "optimalBatch":
                        callback = 'callOptimalBatchLastTimes';
                        break;
                    case "aiOpt":
                        callback = 'callAIOptBacktestLastTimes';
                        break;
                    case "optimalOpt":
                        callback = 'callOptimalOptLastTimes';
                        break;
                    case "rollingBacktest":
                        callback = 'callRollingLastTimes';
                        break;
                    case "porrtfolioBacktest":
                        callback = 'callPortfolioOptLastTimes';
                        break;
                    case "porrtfolioOptBacktest":
                        callback = 'callPortfolioOptLastTimes';
                        break;
                    default:
                        break;
                }
                if (callback !== '') {
                    emitter.emit(callback, lastTimes, items);

                    if (callback == 'callRollingLastTimes') {
                        message.success(languageMessages['queryRequestSucc']);
                    } else {
                        message.success(languageMessages['backtestRequestSucc']);
                    }
                }
            }
        });

        hubProxy.on('ReceiveBacktestStatus', (userName, backtestStatus, backtest) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                let callback = '';
                switch (backtest.Type) {
                    case "backtestStrategy":
                        callback = 'callBacktestStatus';
                        break;
                    case "backtestGridStrategy":
                        callback = 'callBacktestGridStatus';
                        break;
                    case "exploreQTGrid":
                        callback = 'callBacktestGridsStatus';
                        break;
                    case "exploreGridStrategy":
                        callback = 'callOptimalGridStatus';
                        break;
                    case "aiBatch":
                        callback = 'callBestFromBatchBacktestStatus';
                        break;
                    case "optimalBatch":
                        callback = 'callOptimalBatchStatus';
                        break;
                    case "aiOpt":
                        callback = 'callAIOptBacktestStatus';
                        break;
                    case "optimalOpt":
                        callback = 'callOptimalOptStatus';
                        break;
                    case "rollingBacktest":
                        callback = 'callRollingStatus';
                        break;
                    default:
                        break;
                }
                if (callback !== '') {
                    emitter.emit(callback, backtestStatus);
                }
            }
        });

        hubProxy.on('ReceiveBacktestResult', (userName, backtestResult, backtest) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                let callback = '';
                switch (backtest.Type) {
                    case "backtestStrategy":
                        callback = 'callBacktestResult';
                        break;
                    case "backtestGridStrategy":
                        callback = 'callBacktestGridResult';
                        break;
                    case "exploreQTGrid":
                        callback = 'callBacktestGridsResult';
                        break;
                    case "exploreGridStrategy":
                        callback = 'callOptimalGridResult';
                        break;
                    case "aiBatch":
                        callback = 'callBestFromBatchBacktestResult';
                        break;
                    case "optimalBatch":
                        callback = 'callOptimalBatchResult';
                        break;
                    case "aiOpt":
                        callback = 'callAIOptBacktestResult';
                        break;
                    case "optimalOpt":
                        callback = 'callOptimalOptResult';
                        break;
                    case "rollingBacktest":
                        callback = 'callRollingResult';
                        break;
                    default:
                        break;
                }
                if (callback !== '') {
                    emitter.emit(callback, backtestResult, backtest);
                }
            }
        });

        hubProxy.on('ReceiveCustomSymbolGroups', (userName, symbolGroup) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                emitter.emit('callCustomSymbolGroups', symbolGroup);
            }
        });

        hubProxy.on('ReceiveFilter', (userName, filterResult, filter) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                emitter.emit('callFilterRequestResult', filterResult, filter);
            }
        });
        
        hubProxy.on('ReceiveRemoveStrategy', (userName) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                emitter.emit('callRemoveStrategyResult');
            }
        });

        hubProxy.on('ReceiveSaveFilter', (userName, filterResult, filter, customStrategy) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                emitter.emit('callSaveFilterRequestResult', filterResult, filter, customStrategy);
            }
        });


        hubProxy.on('ReceiveFilterAlert', (userName, filterAlert) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {

                // 保存到sessio中
                let filterAlertsCache = JSON.parse(sessionStorage.getItem("FilterAlertsCache") || '{}') || {};

                if (!filterAlertsCache.hasOwnProperty(filterAlert.fi)) {
                    filterAlertsCache[filterAlert.fi] = [];
                }
                filterAlertsCache[filterAlert.fi].unshift(filterAlert);
                
                sessionStorage.setItem("FilterAlertsCache", JSON.stringify(filterAlertsCache));

                let filterAlertCountsCache = JSON.parse(sessionStorage.getItem("FilterAlertCountsCache") || '{}') || {};
                if (filterAlertCountsCache.hasOwnProperty(filterAlert.fi)) {
                    filterAlertCountsCache[filterAlert.fi] += 1;
                } else {
                    filterAlertCountsCache[filterAlert.fi] = 1;
                }
                sessionStorage.setItem("FilterAlertCountsCache", JSON.stringify(filterAlertCountsCache));

                emitter.emit('callfilterAlertResult', filterAlert);
            }
        });

        hubProxy.on('ReceiveScanAlert', (userName, scanAlert, permission, lastTimes) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                emitter.emit('callScanAlertResult', scanAlert, permission, lastTimes);
            }
        });

        hubProxy.on('ReceiveScanResult', (userName, scanAlert) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                emitter.emit('callScanResult', scanAlert);
            }
        });

        hubProxy.on('ReceiveDeployStrategy', (userName, status, deployStrategy) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                emitter.emit('callDeployStrategy', status, deployStrategy);
            }
        });

        hubProxy.on('ReceiveSetStrategyStatus', (userName, status, strategyStatus) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                emitter.emit('callSetStrategyStatus', status, strategyStatus);
            }
        });

        hubProxy.on('ReceivePortfolioOptStatus', (userName, status) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                emitter.emit('callPortfolioOptStatus', status);
            }
        });

        hubProxy.on('ReceivePortfolioOptResult', (userName, result) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                emitter.emit('callPortfolioOptResult', result);
            }
        });

        hubProxy.on('ReceiveScanIntervalMessage', (userName, historicalDate) => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === userName) {
                emitter.emit('callScanIntervalResult', historicalDate);
            }
        });

        hubConnection.start().done(function () {
            //console.log('Connection started!');
            message.success({ content: languageMessages['connectToSysEngineSucc'], key: loginSysMessageStatus });
        }).fail(function (error) {
            message.error({ content: languageMessages['connectToSysEngineFail'], key: loginSysMessageStatus, duration: 5 });
            //console.log('Could not connect', error);
        });
    }

    SendMessageToService(service, userId, msg) {
        var { current } = this.state;
        if (isHubConnection === 1) {
            hubProxy.invoke(service, userId, msg).done((status) => {
                switch (status) {
                    case 1:
                        if (service === 'SendHawkeyeCancel') {
                            if (current === 'hawkeyeList') {
                                var hawkeyeIds = msg.toString().split(',');
                                emitter.emit('callHawkeye', hawkeyeIds, 2);
                            }

                            message.success(languageMessages['stopHawkeyeMsgSendSuccess']);
                        } else if (service === 'SendHawkeye') {
                            emitter.emit('submitHawkeye');

                            var content = <span>{languageMessages['to view, please go']}"<a href="javascript:;" onClick={this.handleMyHawkeye}>{languageMessages['myHawkeye']}</a>"</span>;
                            this.timerModal(languageMessages['settingSuccess'], content);
                        } else if (service === 'SendQuickSetup') {
                            
                        }
                        break;
                    case 2:
                        if (service === 'SendHawkeyeCancel') {
                            if (current === 'hawkeyeList') {
                                emitter.emit('callHawkeye', [], 0);
                            }
                        } else if (service === 'SendHawkeye') {
                            emitter.emit('submitHawkeye');
                        } else if (service === 'SendBacktest') {
                            emitter.emit('callSendBacktestError');
                        } else if (service === 'SendTrade') {
                            emitter.emit('callSendTradeError', status);
                        } else if (service === 'SendStrategyStatus') {
                            emitter.emit('callSendStrategyStatusError', status);
                        } else if (service === 'SendFilter' || service === 'SendScanFilter' || service === 'SendCustomSymbolGroups' || service === 'SendRemoveCustomStrategy') {
                            emitter.emit('callSendError', status);
                        } else if (service === 'startPortfolio' || service === 'startPortfolioOpt') {
                            emitter.emit('callPortfolioOptError', status);
                        } else if (service === 'SendQuickSetup') {

                        }

                        sessionStorage.removeItem('auth');
                        this.setState({ modalVisible: true, loggedIn: false, userId: '', photo: '' });
                        message.error(languageMessages['user.exception']);
                        break;
                    case 5:
                        if (service === 'SendScanFilter') {
                            
                        }
                        break;
                    default:
                        if (service === 'SendHawkeyeCancel') {
                            if (current === 'hawkeyeList') {
                                emitter.emit('callHawkeye', [], 0);
                            }
                            message.error(strReplace(languageMessages['sendFail'], { '{cont}': '' }));
                        } else if (service === 'SendHawkeye') {
                            emitter.emit('submitHawkeye');
                            message.error(strReplace(languageMessages['sendFail'], { '{cont}': '' }));
                        } else if (service === 'SendBacktest') {
                            emitter.emit('callSendBacktestError');
                            //message.error(strReplace(languageMessages['sendFail'], { '{cont}': '' }));
                            message.error(languageMessages['DisconnectSysEngineTryagain']);
                        } else if (service === 'SendTrade') {
                            emitter.emit('callSendTradeError', status);
                        } else if (service === 'SendFilter' || service === 'SendScanFilter' || service === 'SendCustomSymbolGroups' || service === 'SendRemoveCustomStrategy') {
                            emitter.emit('callSendError', status);
                            message.error(strReplace(languageMessages['sendFail'], { '{cont}': '' }));
                        } else if (service === 'startPortfolio' || service === 'startPortfolioOpt') {
                            emitter.emit('callPortfolioOptError', status);
                            message.error(strReplace(languageMessages['sendFail'], { '{cont}': '' }));
                        } else if (service === 'SendQuickSetup') {
                            emitter.emit('callSendError', status);
                        }

                        break;
                }
            }).fail((error) => {
                if (service === 'SendBacktest') {
                    emitter.emit('callSendBacktestError');
                } else if (service === 'SendTrade') {
                    emitter.emit('callSendTradeError', 0);
                } else if (service === 'SendStrategyStatus') {
                    emitter.emit('callSendStrategyStatusError', 0);
                } else if (service === 'SendFilter' || service === 'SendScanFilter' || service === 'SendCustomSymbolGroups' || service === 'SendRemoveCustomStrategy') {
                    emitter.emit('callSendError', 0);
                } else if (service === 'startPortfolio' || service === 'startPortfolioOpt') {
                    emitter.emit('callPortfolioOptError', 0);
                } else if (service === 'SendQuickSetup') {

                }

                //console.log('Invocation of HubMessage failed. Error', error);
                message.error(strReplace(languageMessages['sendFail'], { '{cont}': error }));
            });
        } else {
            if (service === 'SendHawkeyeCancel') {
                if (current === 'hawkeyeList') {
                    emitter.emit('callHawkeye', [], 0);
                }
            } else if (service === 'SendHawkeye') {
                emitter.emit('submitHawkeye');
            } else if (service === 'SendBacktest') {
                emitter.emit('callSendBacktestError');
            } else if (service === 'SendTrade') {
                emitter.emit('callSendTradeError', 0);
            } else if (service === 'SendStrategyStatus') {
                emitter.emit('callSendStrategyStatusError', 0);
            } else if (service === 'SendFilter' || service === 'SendScanFilter' || service === 'SendCustomSymbolGroups' || service === 'SendRemoveCustomStrategy') {
                emitter.emit('callSendError', 0);
            } else if (service === 'startPortfolio' || service === 'startPortfolioOpt') {
                emitter.emit('callPortfolioOptError', 0);
            } else if (service === 'SendQuickSetup') {
                
            }

            message.error(languageMessages['DisconnectSysEngineTryagain']);
        }
    }

    SendIntradayDataToService(userId, symbol, period) {
        if (isHubConnection === 1) {
            hubProxy.invoke('SendIntradayData', userId, symbol, period).done((res) => {
                if (res['status'] !== undefined) {
                    var status = res['status'];
                    switch (status) {
                        case 0:
                            break;
                        case 1:
                            if (res['hd'] !== undefined && res["pr"] !== undefined) {
                                emitter.emit('callTickData', res['hd'], res["pr"]);
                            }
                            break;
                        case 2:
                            sessionStorage.removeItem('auth');
                            this.setState({ modalVisible: true, loggedIn: false, userId: '', photo: '' });
                            message.error(languageMessages['user.exception']);
                            break;
                        default:
                            break;
                    }
                }
            }).fail((error) => {
                //console.log('Invocation of HubMessage failed. Error', error);
                message.error(strReplace(languageMessages['sendFail'], { '{cont}': error }));
            });
        } else {
            message.error(languageMessages['DisconnectSysEngineTryagain']);
        }
    }

    SendHawkeyeConfirm(userName, hawkeyeId, confirmResult, msg) {
        var { current } = this.state;
        if (isHubConnection === 1) {
            hubProxy.invoke('SendHawkeyeConfirm', userName, hawkeyeId, confirmResult).done(function (status) {
                var info = strReplace(languageMessages['sendFail'], { '{cont}': msg });
                switch (status) {
                    case 1:
                        info = languageMessages['applicationSubmitted'];
                        if (current === 'hawkeyeList') {
                            var hawkeyeIds = hawkeyeId.toString().split(',');
                            emitter.emit('ConfirmHawkeye', hawkeyeIds, confirmResult);
                        }
                        message.success(info);
                        break;
                    case 2:
                        if (current === 'hawkeyeList') {
                            emitter.emit('ConfirmHawkeye', [], 0);
                        }
                        sessionStorage.removeItem('auth');
                        this.setState({ modalVisible: true, loggedIn: false, userId: '', photo: '' });
                        info = languageMessages['user.exception'];
                        message.error(info);
                        break;
                    default:
                        if (current === 'hawkeyeList') {
                            emitter.emit('ConfirmHawkeye', [], 0);
                        }
                        message.error(info);
                        break;
                }
            }).fail(function (error) {
                //console.log('Invocation of HubMessage failed. Error', error);
                message.error(strReplace(languageMessages['sendFail'], { '{cont}': error }));
            });
        } else {
            if (current === 'hawkeyeList') {
                emitter.emit('ConfirmHawkeye', [], 0);
            }

            message.error(languageMessages['DisconnectSysEngineTryagain']);
        }
    }

    openNotification = (num) => {
        const key = `open${Date.now()}`;
        const btn = <span>
            <Button size="small" onClick={() => notification.close(key)}>{languageMessages['close']}</Button>
            <span style={{ padding: '0 5px' }}></span>
            <Button size="small" onClick={() => { this.handlePendingOrder(); notification.close(key); }}>{languageMessages['view']}</Button>
        </span>;
        
        var tmpTxt = strReplace(languageMessages['HawkeyeAlertRemind'], { '{cont}': '#' });
        var tmpTxts = tmpTxt.split("#");

        var description = [];
        description.push(tmpTxts[0]);
        description.push(<span key='1232' style={{ fontSize: '24px', color: 'red' }}>{num}</span>);
        description.push(tmpTxts[1]);
        notification.info({
            message: languageMessages['prompt'],
            description: description,//<FormattedMessage id="HawkeyeAlertRemind" values={{ cont: <span style={{ fontSize: '24px', color: 'red' }}>{num}</span> }} />,
            btn,
            key,
            duration: 0,
            onClose: () => {
                //console.log('onClose');
            },
        });
    };

    timerModal(title, content) {
        var secondsToGo = 5;
        const modal = Modal.success({
            title: title,
            content: content,
        });

        setTimeout(() => {
            modal.destroy();
        }, secondsToGo * 1000);
    }

    handlePendingOrder = () => {
        sessionStorage.setItem("hawkeyeListTabActiveKey", '0');
        this.jumpHawkeyeList();
    }

    handleMyHawkeye = () => {
        Modal.destroyAll();

        sessionStorage.setItem("hawkeyeListTabActiveKey", '1');
        this.jumpHawkeyeList();
    }

    handleViewHawkeyeAlert = () => {
        var { hawkeye, current } = this.state;
        if (current === 'hawkeyeList' && hawkeye.Id !== undefined) {
            this.setState({ alertVisible: false });
        } else {
            var tabActiveKey = hawkeye.ConfirmOrder === 1 ? '2' : '0';
            sessionStorage.setItem("hawkeyeListTabActiveKey", tabActiveKey);
            this.jumpHawkeyeList();
        }
    }

    handleCloseHawkeyeAlert = () => {
        this.setState({ alertVisible: false });
    }

    handleViewHawkeyeOrder = () => {
        var { order, current } = this.state;
        if (current === 'hawkeyeList' && order.Id !== undefined) {
            this.setState({ orderVisible: false });
        } else {
            sessionStorage.setItem("hawkeyeListTabActiveKey", '2');
            this.jumpHawkeyeList();
        }
    };

    handleCloseHawkeyeOrder = () => {
        this.setState({ orderVisible: false });
    };

    handleLoginEvent(data) {
        this.setState({ modalVisible: data.visible });
    }

    handleChange(data) {
        this.setState({ code: data.error });
    }

    jumpHawkeyeList() {
        sessionStorage.setItem("MainMenuSelectKey", 'hawkeyeList');
        this.setState({
            current: 'hawkeyeList',
            alertVisible: false,
            orderVisible: false,
        }, () => {
            history.push("/hawkeyeList");
        });
    }

    onLoginClick = () => {
        history.push("/login");
    }

    onRegisterClick = () => {
        this.setState({ modalVisible: false }, () => {
            history.push("/register");
        });
    }

    handleUserClick() {
        this.setState({ current: '' }, () => {
            sessionStorage.setItem("MainMenuSelectKey", 'member');
            history.push("/member");
        });
    }

    handleClick = e => {
        this.setState({
            current: e.key,
        });

        sessionStorage.setItem("MainMenuSelectKey", e.key);

        switch (e.key) {
            case "home":
                history.push("/");
                break;
            case "usStocks":
                window.open("http://us.quancept.com");
                break;
            case "cnStocks":
                window.open("http://www.quancept.cn");
                break;
            case "concept":
                history.push("/concept");
                break;
            case "newFilter":
                history.push("/f");
                break;
            case "myFilter":
                history.push("/mf");
                break;
            case "customSymbolGroups":
                history.push("/customStock");
                break;
            case "scan":
                sessionStorage.removeItem("VernacularStrategyCache");
                history.push("/scan");
                break;
            case "strategy":
                history.push("/strategy");
                break;
            case "customStock":
                history.push("/customStock");
                break;
            case "correlation":
                history.push("/co");
                break;
            case "backtestGrid":
                history.push("/bg");
                break;
            case "optimalGrid":
                history.push("/ogbt");
                break;
            case "mbacktestGrid":
                history.push("/mbg");
                break;
            case "mOptimalGrid":
                history.push("/mogbt");
                break;
            case "optimization":
                history.push("/mob");
                //history.push("/moo");
                break;
            case "scroll":
                //history.push("/mob");
                history.push("/moo");
                break;
            case "aiGrid":
                history.push("/aig");
                break;
            case "backtest":
                history.push("/bt");
                break;
            case "mAIGrid":
                history.push("/maig");
                break;
            case "mAIOptimization":
                history.push("/maib");
                //history.push("/maio");
                break;
            case "rolling":
                history.push("/rr");
                break;
            case "mRolling":
                history.push("/mrr");
                break;

            case "portfolio":
                history.push("/po");
                break;
            case "mpo":
                history.push("/mpo");
                break;

            case "poo":
                history.push("/poo");
                break;
            case "mpoo":
                history.push("/mpoo");
                break;

            case "mbacktest":
                history.push("/mbt");
                break;
            case "simulated-stockStrategy":
                history.push("/si");
                break;
            case "realtime-stockStrategy":
                history.push("/re");
                break;

            case "simulated-generalStrategy":
                history.push("/gs");
                break;
            case "realtime-generalStrategy":
                history.push("/rtgs");
                break;

            case "option":
                history.push("/option");
                break;
            case "factor":
                history.push("/factor");
                break;
            case "download":
                history.push("/download");
                break;
            case "help":
                history.push("/help");
                break;
            case "video":
                history.push("/video");
                break;
            case "hawkeye":
                history.push("/hawkeye");
                break;
            case "hawkeyeList":
                history.push("/hawkeyeList");
                break;
            case "service":
                history.push("/sc");
                break;
            case "about":
                history.push("/about");
            case "contact":
                history.push("/about#contact");
                break;
            case "chat":
                history.push("/chat");
                break;
            case 'order':
                history.push("/order");
                break;
            default:
                break;
        }
    };

    setModalVisible() {
        this.setState({ modalVisible: false });
    }

    renderHawkeyeAlert(hawkeyeAlert) {
        var className = '';
        if (hawkeyeAlert['RangePercent'] !== undefined) {
            if (hawkeyeAlert['RangePercent'] >= 0) {
                className = window.webType === 'US' ? 'common-green' : 'common-red';
            } else {
                className = window.webType === 'US' ? 'common-red' : 'common-green';
            }
        }

        return <div>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['symbolCode']}：</Col>
                <Col span={16}>
                    <div className="common-gutter-row">{hawkeyeAlert['SymbolCode'] + ' ' + hawkeyeAlert['SymbolName']}</div>
                    <div className="common-gutter-row">
                        {languageMessages['latest.price']}：<span style={{ paddingRight: '20px' }}>{hawkeyeAlert['LatestPrice']}</span>
                        {languageMessages['quote.change']}：<span className={className}>{hawkeyeAlert['RangePercent']}%</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['triggerCondition']}：</Col>
                <Col className="common-gutter-row" span={16}>{hawkeyeAlert['TriggerCondition']}</Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['tradeDirection']}：</Col>
                <Col className="common-gutter-row" span={16}>{hawkeyeAlert['TradeDirection'] === 'Close Short' ? languageMessages['closeShort'] : languageMessages['closeLong']}</Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['tradeQuantity']}：</Col>
                <Col className="common-gutter-row" span={16}>{hawkeyeAlert['TradeQuantity']}</Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['triggerDate']}：</Col>
                <Col className="common-gutter-row" span={16}>{hawkeyeAlert['TriggerDateTime']}</Col>
            </Row>
        </div>
    }

    renderHawkeyeOrder(hawkeyeOrder) {
        var className = '';
        if (hawkeyeOrder['RangePercent'] !== undefined) {
            if (hawkeyeOrder['RangePercent'] >= 0) {
                className = window.webType === 'US' ? 'common-green' : 'common-red';
            } else {
                className = window.webType === 'US' ? 'common-red' : 'common-green';
            }
        }

        return <div>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['symbolCode']}：</Col>
                <Col span={16}>
                    <div className="common-gutter-row">{hawkeyeOrder['SymbolCode'] + ' ' + hawkeyeOrder['SymbolName']}</div>
                    <div className="common-gutter-row">
                        {languageMessages['latest.price']}：<span style={{ paddingRight: '20px' }}>{hawkeyeOrder['LatestPrice']}</span>
                        {languageMessages['quote.change']}：<span className={className}>{hawkeyeOrder['RangePercent']}%</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['triggerCondition']}：</Col>
                <Col className="common-gutter-row" span={16}>{hawkeyeOrder['TriggerCondition']}</Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['tradeDirection']}：</Col>
                <Col className="common-gutter-row" span={16}>{hawkeyeOrder['Direction'] === 'Close Short' ? languageMessages['closeShort'] : languageMessages['closeLong']}</Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['tradeQuantity']}：</Col>
                <Col className="common-gutter-row" span={16}>{hawkeyeOrder['Quantity']}</Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['triggerDate']}：</Col>
                <Col className="common-gutter-row" span={16}>{hawkeyeOrder['OrderDateTime']}</Col>
            </Row>
        </div>
    }

    menu() {
        return [
            {
                'title': languageMessages['intl.menu.usStocks'],
                'key': 'usStocks',
                'show': window.webType === 'US' ? false : true,
                'submenu': []
            },
            {
                'title': languageMessages['intl.menu.vernacularStockPicking'],
                'key': 'vernacularStockPicking',
                'show': true,
                'submenu': [
                    {
                        'title': languageMessages['intl.menu.newScan'],
                        'key': 'scan',
                        'show': true,
                        'submenu': []
                    },
                    /**
                    {
                        'title': languageMessages['intl.menu.myStragegy'],
                        'key': 'strategy',
                        'show': true,
                        'submenu': []
                    },*/
                    {
                        'title': languageMessages['intl.menu.customStock'],
                        'key': 'customStock',
                        'show': true,
                        'submenu': []
                    }
                ]
            },
            {
                'title': 'Chat',
                'key': 'chat',
                'show': false,
                'submenu': []
            },
            {
                'title': languageMessages['intl.menu.filter'],
                'key': 'filter',
                'show': true,
                'submenu': [
                    /*
                    {
                        'title': languageMessages['intl.menu.newFilter'],
                        'key': 'newFilter',
                        'show': true,
                        'submenu': []
                    },*/
                    {
                        'title': languageMessages['intl.menu.myFilter'],
                        'key': 'myFilter',
                        'show': true,
                        'submenu': []
                    },
                    {
                        'title': languageMessages['intl.menu.customStock'],
                        'key': 'customSymbolGroups',
                        'show': true,
                        'submenu': []
                    }
                ]
            },
            {
                'title': 'Trade',
                'key': 'order',
                'show': true,
                'submenu': []
            },
            {
                'title': languageMessages['intl.menu.hawkeye'],
                'key': 'mainHawkeye',
                'show': window.webType === 'US' ? false : true,
                'submenu': [
                    {
                        'title': languageMessages['newHawkeye'],
                        'key': 'hawkeye',
                        'show': true,
                        'submenu': []
                    },
                    {
                        'title': languageMessages['myHawkeye'],
                        'key': 'hawkeyeList',
                        'show': true,
                        'submenu': []
                    }
                ]
            },
            {
                'title': languageMessages['intl.menu.grid'],
                'key': 'grid',
                'show': window.webType === 'US' ? false : true,
                'submenu': [
                    {
                        'title': languageMessages['backtestGrid'],
                        'key': 'backtestGrid',
                        'show': true,
                        'submenu': []
                    },
                    {
                        'title': languageMessages['optimalGrid'],
                        'key': 'optimalGrid',
                        'show': window.webType === 'US' ? false : true,
                        'submenu': []
                    },
                    {
                        'title': languageMessages['myBacktest'],
                        'key': 'myBacktest',
                        'show': true,
                        'submenu': [
                            {
                                'title': languageMessages['backtestGrid'],
                                'key': 'mbacktestGrid',
                                'show': true,
                                'submenu': []
                            },
                            {
                                'title': languageMessages['optimalGrid'],
                                'key': 'mOptimalGrid',
                                'show': window.webType === 'US' ? false : true,
                                'submenu': []
                            },
                            {
                                'title': languageMessages['optimizationGrid'],
                                'key': 'optimization',
                                'show': window.webType === 'US' ? false : true,
                                'submenu': []
                            },
                            /**
                            {
                                'title': languageMessages['ScrollOptimization'],
                                'key': 'scroll',
                                'show': window.webType === 'US' ? false : true,
                                'submenu': []
                            }
                            */
                        ]
                    }
                ]
            },
            {
                'title': languageMessages['strategyExcavate'],
                'key': 'strategyExcavate',
                'show': false,
                'submenu': [
                    {
                        'title': languageMessages['rollingStrategy'],
                        'key': 'rolling',
                        'show': true,
                        'submenu': []
                    },
                    {
                        'title': languageMessages['AIincrease'],
                        'key': 'aiGrid',
                        'show': true,
                        'submenu': []
                    },
                    {
                        'title': languageMessages['combination-strategyExcavate'],
                        'key': 'backtest',
                        'show': window.webType === 'US' ? false : true,
                        'submenu': []
                    },
                    /**
                    {
                        'title': 'Portfolio',
                        'key': 'po',
                        'show': window.webType === 'US' ? true : false,
                        'submenu': []
                    },
                    {
                        'title': 'Portfolio optimize',
                        'key': 'poo',
                        'show': window.webType === 'US' ? true : false,
                        'submenu': []
                    },
                    */
                    {
                        'title': languageMessages['myExcavate'],
                        'key': 'myExcavate',
                        'show': true,
                        'submenu': [
                            {
                                'title': languageMessages['rollingStrategy'],
                                'key': 'mRolling',
                                'show': true,
                                'submenu': []
                            },
                            {
                                'title': languageMessages['AIincrease'],
                                'key': 'mAIGrid',
                                'show': true,
                                'submenu': []
                            },
                            {
                                'title': languageMessages['optimizationGrid'],
                                'key': 'mAIOptimization',
                                'show': true,
                                'submenu': []
                            },
                            {
                                'title': languageMessages['combination-strategyExcavate'],
                                'key': 'mbacktest',
                                'show': window.webType === 'US' ? false : true,
                                'submenu': []
                            },
                            /**
                            {
                                'title': languageMessages['my.portfolio'],
                                'key': 'mpo',
                                'show': true,
                                'submenu': []
                            },
                            {
                                'title': languageMessages['my.portfolio'],
                                'key': 'mpoo',
                                'show': true,
                                'submenu': []
                            },
                            */
                        ]
                    }
                ]
            },
            {
                'title': 'Strategy',
                'key': 'myTrade',
                'show': true,
                'submenu': [
                    {
                        'title': 'Coming soon...',
                        'key': 'None',
                        'show': true,
                        'submenu': []
                    },
                    /**
                    {
                        'title': 'Simulation',
                        'key': 'simulated',
                        'show': true,
                        'submenu': [
                            {
                                'title': languageMessages['stockStrategy'],
                                'key': 'simulated-stockStrategy',
                                'show': true,
                                'submenu': []
                            },
                            {
                                'title': languageMessages['generalStrategy'],
                                'key': 'simulated-generalStrategy',
                                'show': true,
                                'submenu': []
                            },
                        ]
                    },
                    {
                        'title': 'Live',
                        'key': 'realtime',
                        'show': true,
                        'submenu': [
                            {
                                'title': languageMessages['stockStrategy'],
                                'key': 'realtime-stockStrategy',
                                'show': true,
                                'submenu': []
                            },
                            {
                                'title': languageMessages['generalStrategy'],
                                'key': 'realtime-generalStrategy',
                                'show': true,
                                'submenu': []
                            },
                        ]
                    }
                    */
                ]
            },
            {
                'title': languageMessages['intl.menu.option'],
                'key': 'mainOption',
                'show': window.webType === 'US' ? false : true,
                'submenu': [
                    {
                        'title': languageMessages['optionStrategyScan'],
                        'key': 'option',
                        'show': true,
                        'submenu': []
                    }
                ]
            },
            {
                'title': languageMessages['factorService'],
                'key': 'factor',
                'show': window.webType === 'US' ? false : true,
                'submenu': []
            },
            {
                'title': languageMessages['intl.menu.download'],
                'key': 'download',
                'show': true,
                'submenu': []
            },
            {
                'title': languageMessages['pricing'],
                'key': 'service',
                'show': window.webType === 'US' ? true : false,
                'submenu': []
            },
            {
                'title': languageMessages['videoTutorial'],
                'key': 'video',
                'show': window.webType === 'US' ? false : true,
                'submenu': []
            },
            {
                'title': languageMessages['intl.menu.help'],
                'key': 'help',
                'show': window.webType === 'US' ? false : true,
                'submenu': []
            }
        ];
    }

    renderSubMenu = data =>
        data.map(item => {
            if (item.show) {
                if (item.submenu.length > 0) {
                    return <SubMenu key={item.key} title={item.title}>
                        {
                            this.renderSubMenu(item.submenu)
                        }
                    </SubMenu>
                } else {
                    return <Menu.Item key={item.key}>{item.title}</Menu.Item>
                }
            }
        })

    renderMenu() {
        return <Menu onClick={this.handleClick} selectedKeys={[this.state.current]} mode="horizontal">
            {
                this.renderSubMenu(this.menu())
            }
        </Menu>
    }

    onShowLogin = () => {
        this.setState({
            showLogin: true,
            showRegister: false
        });
    }

    onShowRegister = () => {
        this.setState({
            showLogin: false,
            showRegister: true,
        });
    }

    toShowForgetPassword = e => {
        e.preventDefault();
        this.setState({ modalVisible: false }, () => {
            history.push("/forget");
        });
    }

    render() {
        if (this.state.current !== 'scan') {
            window.scrollTo(0, 0);
        }

        return (<Header className='common-header'>
            <Row>
                <Col xs={10} sm={5} style={{ zIndex: 1 }}>
                    <div className="logo"><a href="/"><img src="/static/images/logo.png" width="137" alt={languageMessages['title']} title="Quancept" /></a></div>
                    {window.webType === 'US' ? '' : <span className="common-tip">
                        {languageMessages['intl.menu.cnStocks']}
                    </span>
                    }
                </Col>
                <Col xs={4} sm={14}>
                    {this.renderMenu()}
                </Col>
                <Col xs={10} sm={5}>
                    {this.state.loggedIn ? (<UserMenu username={this.state.userId} photo={this.state.photo} userClick={this.handleUserClick.bind(this)} />) : (<LoginRegisterButtons onLoginAction={this.onLoginClick} onRegisterAction={this.onRegisterClick} />)}
                </Col>
            </Row>
            <Modal title={languageMessages['intelligentHawkeyeAlert']}
                visible={this.state.alertVisible}
                okText={languageMessages['view']}
                onOk={this.handleViewHawkeyeAlert}
                cancelText={languageMessages['close']}
                onCancel={this.handleCloseHawkeyeAlert}>
                {this.renderHawkeyeAlert(this.state.hawkeye)}
            </Modal>

            <Modal title={languageMessages['orderInfo']}
                visible={this.state.orderVisible}
                okText={languageMessages['view']}
                onOk={this.handleViewHawkeyeOrder}
                cancelText={languageMessages['close']}
                onCancel={this.handleCloseHawkeyeOrder}>
                {this.renderHawkeyeOrder(this.state.order)}
            </Modal>
            
            <Modal
                title={<div className='form-logo'></div>}
                className='dialog-common-box'
                style={{ top: 64 }}
                width={480}
                zIndex={1005}
                footer={null}
                visible={this.state.modalVisible}
                maskClosable={false}
                onCancel={() => this.setModalVisible()}>
                
                <div style={{ display: this.state.showLogin ? '' : 'none' }}>
                    <WrappedLoginForm {...this.state} status={this.props.member.status} dispatch={this.props.dispatch} loginEvent={this.handleLoginEvent.bind(this)} handleChange={this.handleChange.bind(this)} />
                </div>
                <div style={{ display: this.state.showRegister ? '' : 'none' }}>
                    <WrappedRegisterForm {...this.state} status={this.props.member.status} dispatch={this.props.dispatch} handleChange={this.handleChange.bind(this)} />
                </div>
                {this.state.code === 'ERROR' ? (<Alert message={this.state.message} type="error" />) : ''}

                {this.state.showLogin && (<div style={{ padding: '10px 0' }}>
                    <a href="javascript:;" onClick={this.onShowRegister}>{languageMessages['intl.register']}</a>
                    <a className="login-form-forgot" href="javascript:;" onClick={this.toShowForgetPassword}>{languageMessages['intl.login.forgotPassword']}</a>
                </div>)}
                {this.state.showRegister && (<div>
                    <a href="javascript:;" onClick={this.onShowLogin}>{languageMessages['Login to existing quancept account']} ></a>
                </div>)}
                
            </Modal>
        </Header>)
    }
}

function mapStateToProps(state) {
    return {
        member: state.member,
        fail: state.fail,
    };
}

const page = connect(mapStateToProps)(HeaderPage);
export { page as default }